import * as React from "react";

import { titles } from "../../../constants/titles";
import {
  Context,
  fetchSummaryPerClass,
  fetchSummaryPerTeacher,
  fetchReports,
  fetchTotalStatus,
  updateSchoolStockCToC,
  deleteRealization,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StatusUtilizationBoard from "../../../templates/manager/StatusUtilizationBoard";

export default () => {
  const { state, dispatch } = React.useContext(Context);

  const fetchReportsFunc = React.useCallback(
    (target: string) => {
      dispatch(fetchReports(target));
    },
    [dispatch],
  );

  const fetchTotalStatusFunc = React.useCallback(
    (target: string) => {
      dispatch(fetchTotalStatus(target));
    },
    [dispatch],
  );

  const fetchSummaryPerClassFunc = React.useCallback(
    (target: string, span: string) => {
      dispatch(fetchSummaryPerClass(target, span));
    },
    [dispatch],
  );

  const fetchSummaryPerTeacherFunc = React.useCallback(
    (target: string, span: string) => {
      dispatch(fetchSummaryPerTeacher(target, span));
    },
    [dispatch],
  );

  const schoolStockCToCEnabled =
    state.manager?.school?.stock_c_to_c_enabled ?? false;

  const updateSchoolStockCToCFunc = (schoolStockCToC: boolean) => {
    // もしステータスが同じなら更新しない
    if (schoolStockCToC === schoolStockCToCEnabled) return;
    dispatch(updateSchoolStockCToC(schoolStockCToC));
  };

  const deleteRealizationFunc = React.useCallback(
    (id: number) => {
      dispatch(deleteRealization(id));
    },
    [dispatch],
  );

  return (
    <div>
      <Breadcrumb currentTitle={titles.gearStatus} />
      <StatusUtilizationBoard
        title={titles.gearStatus}
        fetchTotalStatus={fetchTotalStatusFunc}
        fetchReports={fetchReportsFunc}
        fetchSummaryPerClass={fetchSummaryPerClassFunc}
        fetchSummaryPerTeacher={fetchSummaryPerTeacherFunc}
        deleteRealization={deleteRealizationFunc}
        total_status={state.total_status}
        class_summaries={state.class_summaries}
        report_entries={state.report_entries}
        teacher_summaries={state.teacher_summaries}
        updateSchoolStockCToC={updateSchoolStockCToCFunc}
        schoolStockCToCEnabled={schoolStockCToCEnabled}
      />
    </div>
  );
};
